import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Header from "../InitialPage/Sidebar/Header";
import Sidebar from "../InitialPage/Sidebar/Sidebar";
// import Loader from "../InitialPage/Sidebar/LoadingSpinner";
import { privateRoutes, posRoutes, publicRoutes } from "./router.link";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { InactivityRedirect } from "../store/InactivityRedirect";
import { all_routes } from "../Router/all_routes";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ThemeSettings from "../InitialPage/themeSettings";


const route = all_routes;

const MySwal = withReactContent(Swal);

// Fonction pour afficher une alerte stylisée
const showAlert = (config) => {
  MySwal.fire({
    ...config,
    icon: config.type || "success",
    confirmButtonText: "OK",
  });
};

// Composant pour protéger les routes
const ProtectedRoute = ({ children, roles }) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const userRole = useSelector((state) => state.auth.role);

  if (!isLoggedIn) {
    return <Navigate to={route.signin} replace />;
  }

  if (roles && !roles.includes(userRole)) {
    // Afficher une alerte de succès
    showAlert({
      text: "Vous n'avez pas les autorisations nécessaires pour accéder à cette page.",
      type: "error",
    });
    return <Navigate to={route.signin} replace />;
  }

  return children;
};

// Validation des props
ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  roles: PropTypes.arrayOf(PropTypes.string),
};

// Composant pour les pages publiques (connexion, etc.)
const Authpages = () => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  if (isLoggedIn) {
    const redirectPath = route.allmodule;
    return <Navigate to={redirectPath} replace />;
  }

  return (
    <div>
      <Outlet />
      {/* <Loader /> */}
      <ThemeSettings />

    </div>
  );
};

// Composant pour les pages avec le POS
const Pospages = () => (
  <div>
    <Header />
    <Outlet />
    {/* <Loader /> */}
    <ThemeSettings />

  </div>
);

// Composant pour les pages privées
const HeaderLayout = () => {
  const data = useSelector((state) => state.toggle_header);
  const location = useLocation(); // Récupérer la route active

  return (
    <div className={`main-wrapper ${data ? "header-collapse" : ""}`}>
      <Header />
      {/* Passer la route active au Sidebar */}
      <Sidebar currentRoute={location.pathname} />     
      <Outlet />
      {/* <Loader /> */}
      <ThemeSettings />

    </div>
  );
};

// Configuration des routes
const AllRoutes = () => {
  return (
    <Routes>
      {/* Route par défaut */}
      <Route path="*" element={<Navigate to={route.error404} replace />} />
      
      {/* Routes publiques */}
      <Route path="/" element={<Authpages />}>
        {publicRoutes.map((route, id) => (
          <Route path={route.path} element={route.element} key={id} />
        ))}
      </Route>

      {/* Routes POS */}
      <Route path="/overview" element={<Pospages />}>
        {posRoutes.map((route) => (
          <Route
            key={route.id}
            path={route.path}
            element={
              <ProtectedRoute roles={route.roles}>
                <InactivityRedirect>
                  {route.element}
                </InactivityRedirect>
              </ProtectedRoute>
            }
          />
        ))}
      </Route>

      {/* Routes privées */}
      <Route path="/" element={<HeaderLayout />}>
        {privateRoutes.map((route) => (
          <Route
            key={route.id}
            path={route.path}
            element={
              <ProtectedRoute roles={route.roles}>
                <InactivityRedirect>
                  {route.element}
                </InactivityRedirect>
              </ProtectedRoute>
            }
          />
        ))}
      </Route>

    
    </Routes>
  );
};

export default AllRoutes;
